import { Action, handleActions } from "redux-actions";

import { IScormPackage, RequestState } from "../../types/common";
import * as actions from "../actions";

export interface IState {
  deleteScormPackageRequestState: RequestState;
  fetchScormPackagesStatus: RequestState;
  scormPackages: IScormPackage[];
}

const INITIAL_STATE: IState = {
  deleteScormPackageRequestState: RequestState.IDLE,
  fetchScormPackagesStatus: RequestState.IDLE,
  scormPackages: [],
};

const fetchExportedScormPackages = (state: IState, _: Action<void>) => ({
  ...state,
  fetchScormPackagesStatus: RequestState.PENDING,
});

const fetchExportedScormPackagesFailure = (state: IState, _: Action<void>) => ({
  ...state,
  fetchScormPackagesStatus: RequestState.FAILED,
});

const fetchExportedScormPackagesSuccess = (state: IState, action: Action<IScormPackage[]>) => ({
  ...state,
  fetchScormPackagesStatus: RequestState.SUCCEEDED,
  scormPackages: action.payload,
});

const mount = (_: IState, __: Action<void>) => INITIAL_STATE;

const unmount = (_: IState, __: Action<void>) => INITIAL_STATE;

const deleteScormPackage = (state: IState, _: Action<string>): IState => ({
  ...state,
  deleteScormPackageRequestState: RequestState.PENDING,
});

const deleteScormPackageFailure = (state: IState, _: Action<{ message: string }>): IState => ({
  ...state,
  deleteScormPackageRequestState: RequestState.FAILED,
});

const deleteScormPackageSuccess = (state: IState, action: Action<IScormPackage[]>): IState => ({
  ...state,
  deleteScormPackageRequestState: RequestState.SUCCEEDED,
  scormPackages: action.payload,
});

type ActionPayload = IScormPackage[] | string | void | { message: string };

export default handleActions<IState, ActionPayload>(
  {
    [actions.Action.DELETE_SCORM_PACKAGE]: deleteScormPackage,
    [actions.Action.DELETE_SCORM_PACKAGE_FAILURE]: deleteScormPackageFailure,
    [actions.Action.DELETE_SCORM_PACKAGE_SUCCESS]: deleteScormPackageSuccess,
    [actions.Action.FETCH_EXPORTED_SCORM_PACKAGES]: fetchExportedScormPackages,
    [actions.Action.FETCH_EXPORTED_SCORM_PACKAGES_FAILURE]: fetchExportedScormPackagesFailure,
    [actions.Action.FETCH_EXPORTED_SCORM_PACKAGES_SUCCESS]: fetchExportedScormPackagesSuccess,
    [actions.Action.MOUNT]: mount,
    [actions.Action.UNMOUNT]: unmount,
  },
  INITIAL_STATE
);
